import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClientDTO, ParkerRegistrationType } from '../../../../../base/models/models.swagger.generated';
import { ClientService } from '../../../../../base/services/client/client.service';
import { DatePickerComponent, DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { TranslateModule } from '@ngx-translate/core';
import { EnumDropDownListComponent } from '../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { ClientAutocompleteComponent } from '../../../../../base/shared/client-autocomplete/client-autocomplete.component';

@Component({
    selector: 'app-parker-registration-form',
    templateUrl: './parker-registration-form.component.html',
    styleUrls: ['./parker-registration-form.component.scss'],
    imports: [
        ReactiveFormsModule,
        ClientAutocompleteComponent,
        DatePickerModule,
        EnumDropDownListComponent,
        TranslateModule
    ]
})
export class ParkerRegistrationFormComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(ClientAutocompleteComponent)
  public clientAutocomplete: ClientAutocompleteComponent;

  @ViewChild('startTime')
  public startTimePicker: DatePickerComponent;

  @ViewChild('endTime')
  public endTimePicker: DatePickerComponent;

  @Input()
  public form: UntypedFormGroup;

  @Output()
  public searchDTOChanged = new EventEmitter<any>();

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
    }
    // Defer the event emission to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.onClientSelected(value);
    });
  }

  public ParkerRegistrationType = ParkerRegistrationType;
  private subscriptions = [];

  constructor(protected clientService: ClientService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.form.valueChanges.subscribe(() => {
        if (this.endTimePicker) {
          if (this.form.get('startDate').value) {
            this.endTimePicker.min = this.form.get('startDate').value;
          } else {
            this.endTimePicker.min = null;
          }
        }


        if (this.startTimePicker) {
          if (this.form.get('endDate').value) {
            this.startTimePicker.max = this.form.get('endDate').value;
          } else {
            this.startTimePicker.max = null;
          }
        }

        this.searchDTOChanged.emit();
      }));
  }

  ngAfterViewInit(): void {
    if (!this.selectedClient) {
      this.focusClientAutocomplete();
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public onClientSelected(client: ClientDTO): void {
    if (client) {
      this.searchDTOChanged.emit();
    }
  }

  private focusClientAutocomplete(): void {
    if (this.clientAutocomplete) {
      this.clientAutocomplete.focus();
    }
  }
}
